export const transformImage = (url, value) => {
    let result = url;
    if (url && value) {
        const wordAfter = "image/upload/";

        const parts = url.split(wordAfter);
        result = parts.join(wordAfter + value + "/");
    }
    return result;
};

export const getMobileQuery = () => {
    return window.innerWidth;
};

export const replaceUnsupportedImageExtension = (url) => {
    const supportedExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.webp'];
    const currentExtension = url.slice(url.lastIndexOf('.')).toLowerCase();
    if (!supportedExtensions.includes(currentExtension)) {
        // Replace the extension with '.jpg'
        const newUrl = url.slice(0, url.lastIndexOf('.')) + '.jpg';
        return newUrl;
    }
    return url;
};

// https://res.cloudinary.com/dqjknomcl/image/upload/l_text:Arial_24_bold:Colored%2520text,co_rgb:B90FAE/v1695824042/qdn2lre6glr8rlwjy2jo.png
export const addTextToCloudinaryImage = (url, coverDesign, templateTitle) => {
    let result = url;
    if (url && coverDesign && templateTitle) {
        let transedUrl = "";
        const splittedImage = url.split("/");

        const textSize = getFontSize(coverDesign.textSize);

        const color = coverDesign.textColor.replace('#', "");

        const value = `l_text:${coverDesign.fontName}_${textSize}_${coverDesign.fontWeight}:${templateTitle},co_rgb:${color},o_100,g_south,y_150/`;

        const len = splittedImage.length - 1;
        splittedImage.forEach((part, idx) => {
            if (part.includes('c_crop')) {
                transedUrl += part + '/' + value;
            } else {
                transedUrl += part;
                if (len !== idx) {
                    transedUrl += "/"
                }
            }
        });

        return transedUrl;
    }
    return result;
};

export function getFontSize(sizeName, partOfBook) {
    let size = 15;
    switch (sizeName) {
        case 'XS':
            size = 20;
            break;
        case 'S':
            size = 25;
            break;
        case 'M':
            size = 30;
            break;
        case 'L':
            size = 40;
            break;
        case 'XL':
            size = 50;
            break;
    }
    return size
}

export function getSizeByLetters(text) {
    let result = "XL";
    const textSize = text.length;
    const howmanyWords = text.split(" ").length;
    if(howmanyWords === 1) {
        if(textSize > 10) {
            result = "M";
        }
        if(textSize > 14) {
            result = "S";
        }
        if (textSize > 22) {
            result = "XS";
        }
    }else {
        if(textSize > 10) {
            result = "L";
        }
        if(textSize > 14) {
            result = "M";
        }
        if (textSize > 26) {
            result = "S";
        }
        if(textSize > 40) {
            result = "XS";
        }
    }
    return result;
}

export function makeImgAsPrint(image) {
    let result = image;
    if (image.includes("https://mebook.b-cdn.net/")) {
        result = image.replace("https://mebook.b-cdn.net/", "https://print.mebook.ai/");
    }

    if(image.includes("https://cdn.mebook.ai/")){
        result = image.replace("https://cdn.mebook.ai/", "https://print.mebook.ai/");
    }

    return result;
}

export function calculateFontSize(currentWidth, baseWidth = 814, baseFontSize = 24) {
    return (currentWidth / baseWidth) * baseFontSize;
}
